<template>
<div class="support">
    <div class="dragen-head"></div>
    <div class="support-main">
        <div v-if="!isSelf">
            <div class="support-top" v-show="!support">
                <div class="headimg"><img :src="helpuser.head_img_url" alt=""></div>
                <div class="support-detail">
                    <span style="color: #4a8c7e">@{{helpuser.nickname}}</span>邀您助力端午助他瓜分三万大奖~
                </div>
            </div>
            <!-- 已助力后的页面 -->
            <div class="support-text" v-show="support">
                <div class="success"><img src="../../assets/H5img/support/success.png" alt=""></div>
                <div class="support-detail">
                    您已为<span style="color: #4a8c7e">@{{helpuser.nickname}}</span>助力端午一起玩游戏瓜分三万大奖吧~
                </div>
            </div>
            <div class="awards"></div>
        </div>
        <div class="is-self" v-if="isSelf">
            <div class="circle-success"></div>
            <div class="self-top">
                <div v-if="support_list.count != 0">恭喜您！有{{support_list.count}}位小伙伴为您助力</div>
                <div v-if="support_list.count == 0">暂无小伙伴为您助力哦</div>
                <div>您已拥有<span class="big-span">{{userdata.game_num}}</span>次划龙舟的机会~</div>
                <!-- <div v-if="userdata.game_num == 0">您暂时没有划龙舟的机会~</div> -->
            </div>
            <div class="support-con">
                <div class="support-title">继续邀请好友助力吧</div>
                <div class="support-people">
                    <div class="people-headimg" v-for="(item, index) in support_list.list" :key="index">
                        <img :src="item.boost_head_img_url" alt="">
                        <div class="line"></div>
                    </div>
                    <!-- <div class="right-line"></div> -->
                </div>
                <div class="rank-btn" @click="toRankList"></div>
                <div class="support-tips"></div>
            </div>
        </div>
    </div>
    <div class="support-btn" v-if="!support && !isSelf" @click="supportClick">{{btnText}}</div>
    <div class="support-btn" v-if="support && !isSelf" @click="startGame">开始游戏</div>
    <div class="bottom-bg"></div>
     <!-- 音乐控制 -->
    <!-- <div :class="music_on?'music_box music_rotate':'music_box'" :style="{backgroundImage: musicImgUrl, backgroundSize:'cover',backgroundRepeat:'no-repeat',backgroundPosition:'center'}" @click="mp3Control"></div> -->
</div>
</template>

<script>
export default {
    data() {
        return {
            gameOver: '', //游戏是否结束
            support: false,
            btnText: '点击助力',
            isSelf: false,
            openId: '', //自己id
            support_list: [],
            userdata: '', //当前用户的数据
            helpuser: '', //需要助力人的信息
        }
    },
    methods: {
        //点击助力
        supportClick() {
            let boostOpenId = localStorage.getItem('openId')
            let OpenId = this.helpuser.open_id
            let boostNickname = localStorage.getItem('username')
            let boostHeadImgUrl = localStorage.getItem('avatar')
            //好友助力
            this.$axios.post('/h5/api/createBoost', {
                openId: OpenId,
                boostOpenId: boostOpenId,
                boostNickname: boostNickname,
                boostHeadImgUrl: boostHeadImgUrl
            }).then(res => {
                console.log(res)
                if(res.data.code == 0) {
                    this.support = true
                    // this.btnText = '开始游戏'
                } else {
                    this.support = true
                    // this.btnText = '开始游戏'
                }
            })
        },
        startGame() {
            this.$router.replace({
                path: '/Mindex'
            })
        },
        toRankList() {
            this.$router.replace({
                path: '/Mrank'
            })
        },
        //好友助力前获取用户信息并判断是否已经助力过
        getUserSupport(boostOpenId, OpenId) {
            // let openId = localStorage.getItem('openId')
            // let boostOpenId = this.helpuser.open_id
            // let boostOpenId = localStorage.getItem('bbbbbb')
            this.$axios.post('/h5/api/getUserInfo',{
                openId: OpenId,
                boostOpenId: boostOpenId,
            }).then(res => {
                console.log(res,'判断是否助力')
                if(res.data.code == 0) {
                    this.helpuser = res.data.data.user
                    // this.supportClick()
                } else {
                    this.helpuser = res.data.data.user
                    this.support = true
                }
                if(res.data.data.user == null) {
                    // this.$router.replace({
                    //     path: '/Mindex'
                    // })
                }
            })
        },
        //获取助力详情列表
        getSupportList() {
            let openId = localStorage.getItem('openId')
            console.log(openId)
            this.$axios.post('/h5/api/getShareList', {
                openId: openId,
            }).then(res => {
                console.log(res)
                if (res.data.code == 0) {
                    let support_list = res.data.data.data
                    console.log(support_list)
                    this.support_list = support_list
                    this.userdata = res.data.data.user
                }
            })
        },
        // 根据openId获取需要助力人的信息
        getUserInfo(openId) {
            this.$axios.post('/h5/api/createUser', {
                openId: openId,
            }, {}).then(res => {
                let helpuser = res.data.data.user
                this.helpuser = helpuser
            })
        },
        /**
         * 根据参数名 获取 URL 路径中的参数
         * @param {String} name 要读取的参数名称
         */
        GetUrlParam(paraName) {
            var url = decodeURIComponent(document.location.toString());
            var arrObj = url.split("?");
            if (arrObj.length > 2) {
                for (var x = 1; x < arrObj.length; x++) {
                    var arrPara = arrObj[x].split("&");
                    var arr;
                    for (var i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");
                        if (arr != null && arr[0] == paraName) {
                            return arr[1];
                        }
                    }
                }
                return "";
            } else if (arrObj.length > 1) {
                var arrPara = arrObj[1].split("&");
                var arr;
                for (var x = 0; x < arrPara.length; x++) {
                    arr = arrPara[x].split("=");
                    if (arr != null && arr[0] == paraName) {
                        return arr[1];
                    }
                }
                return "";
            } else {
                return "";
            }
        },

        /**
         * 根据参数名 获取 URL 路径中的参数
         * @param {String} name 要读取的参数名称
         */
        getUrlParam(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
            let url = window.location.href.split('#')[0]
            let search = url.split('?')[1]
            if (search) {
                var r = search.substr(0).match(reg)
                if (r !== null) return unescape(r[2])
                return null
            } else {
                return null
            }
        },

          //设置分享
        setWxShare() {
            let shareUrl
            if(this.isSelf) {
                let openId = localStorage.getItem('openId')
                shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}`
            }else {
                shareUrl = `https://smalltea.xiaoxxx.cn/#/`
            }
            // let avatar = localStorage.getItem('avatar')
            // let username = localStorage.getItem('username')
            // let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}&myavatar=${avatar}&myname=${username}`
            // shareUrl = "http://test.smalltea.xiaoxxx.cn/#/Msupport?myopenid=123&myavatar=888"
            // alert(shareUrl)
            // 微信分享
            window.wx.ready(() => {
                // 分享好友
                window.wx.updateAppMessageShareData({
                    title: "乘风破浪·粽享端午", // 分享标题
                    desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        console.log(url);
                        // 设置成功
                        // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
                    }
                });
                // 分享朋友圈
                window.wx.updateTimelineShareData({
                    title: "乘风破浪·粽享端午", // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数', '1', '1']);
                    }
                });
                // 1.2.0 老接口
                wx.onMenuShareAppMessage({
                    title: "乘风破浪·粽享端午", // 分享标题
                    desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
                    }
                });
                wx.onMenuShareTimeline({
                    title: "乘风破浪·粽享端午", // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数', '1', '1']);
                    }
                });
            });
        }
    },
    created() {
        let href = window.location.href;
        if (localStorage.getItem('openId')) { //如果不是新用户
            let support = this.$route.query.support
            if (support) {
                // localStorage.setItem('bbbbbb',support)
                this.getUserSupport(localStorage.getItem('openId'),support)
                localStorage.removeItem('need_support')
            }else {
                let have_self_openid = href.indexOf('myopenid')
                if (have_self_openid) {
                    let my_openId = this.GetUrlParam('myopenid')
                    console.log(my_openId)
                    
                    localStorage.setItem('supportOpenid', my_openId)
                    localStorage.setItem('bbbbbb', my_openId)
                    if(!localStorage.getItem('need_support')) {
                        this.getUserSupport(localStorage.getItem('openId'),localStorage.getItem('bbbbbb'))
                    }
                    // localStorage.setItem('support_name',my_name)
                    // this.getUserSupport(localStorage.getItem('openId'),my_openId)
                }
                if (localStorage.getItem('bbbbbb') == localStorage.getItem('openId')) {
                        this.isSelf = true
                        this.getSupportList()
                }
            }
        } else { //如果是新用户助力
            if (href.indexOf('?')) { //有参数,有openid的情况，把openid存缓存
                let support = this.getUrlParam('support')
                localStorage.setItem('need_support', 1)
                let have_self_openid = href.indexOf('myopenid')
                if (have_self_openid != -1) {
                    let my_openId = this.GetUrlParam('myopenid')
                    localStorage.setItem('supportOpenid', my_openId)
                    localStorage.setItem('bbbbbb', my_openId)
                    let s_openid = encodeURIComponent(my_openId)
                    setTimeout(() => {
                        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfda9ee4f018ce8ee&redirect_uri=https://api.smalltea.xiaoxxx.cn/weixin/api/callbackFortune?returnUrl=https://smalltea.xiaoxxx.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                    }, 0)
                }
            }

        }
    },
    mounted() {
        this.gameOver = localStorage.getItem('game-over')
        setTimeout(() => {
            this.setWxShare()
        }) 
    }
}
</script>

<style scoped>
.support {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 13rem;
    background-color: #d3f5ea;
    /* background: url('../../assets/H5img/indexImg/bg-index.jpg') no-repeat;
    background-size: cover;
    background-position: center; */
    overflow: hidden;
}

.bottom-bg {
    position: absolute;
    width: 7.5rem;
    height: 5.43rem;
    bottom: -1rem;
    left: 0;
    background: url('../../assets/H5img/focusImg/focus-bottom-bg.png') no-repeat;
    background-size: cover;
    background-position: center;
}

.dragen-head {
    position: absolute;
    top: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 5.18rem;
    height: 4.02rem;
    background: url('../../assets/H5img/support/dargen.png') no-repeat;
    background-size: cover;
    background-position: center;
}

.support-main {
    position: absolute;
    width: 6.52rem;
    height: 7.53rem;
    top: 4rem;
    left: 50%;
    transform: translateX(-50%);
    background: url('../../assets/H5img/support/content-bg.png') no-repeat;
    background-size: cover;
    background-position: center;
    z-index: 2;
    padding: 0.6rem 0.5rem;
}

.support-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 1.75rem;
    border-bottom: 1px solid #e0e5e7;
}

.support-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 1.75rem;
    border-bottom: 1px solid #e0e5e7;
}

.headimg {
    width: 1.34rem;
    /* height: 1.34rem; */
    border-radius: 50%;
    /* overflow: hidden; */
    margin-right: 0.2rem;
}

.headimg img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.support-detail {
    font-size: 0.3rem;
    line-height: 1.4;
    color: #254740;
}

.awards {
    width: 5.1rem;
    height: 4.74rem;
    margin: 0 auto;
    margin-top: 0rem;
    background: url('../../assets/H5img/support/goods.png') no-repeat;
    background-size: cover;
    background-position: center;
}

.support-btn {
    position: absolute;
    width: 6.52rem;
    height: 0.98rem;
    background: url('../../assets/H5img/support/button.png') no-repeat;
    background-size: cover;
    background-position: center;
    top: 12rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    text-align: center;
    line-height: 0.98rem;
    font-size: 0.36rem;
    color: #ffffff;
}

.success-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 1.75rem;
    border-bottom: 1px solid #e0e5e7;
}

.success {
    width: 0.8rem;
    /* height: 0.8rem; */
    margin-right: 0.2rem;
}

.success img {
    width: 100%;
}

.circle-success {
    width: 0.8rem;
    height: 0.8rem;
    background: url('../../assets/H5img/support/success.png') no-repeat;
    background-size: cover;
    background-position: center;
    margin: 0 auto;
}

.is-self {
    text-align: center;
}

.self-top {
    width: 5.3rem;
    height: 1.2rem;
    border-bottom: 1px solid #e0e5e7;
    margin-top: 0.1rem
}

.self-top {
    font-size: 0.3rem;
    color: #254740;
    line-height: 1.4;
}

.big-span {
    font-size: 0.4rem;
    color: #e46c36;
    font-weight: bold;
}

.support-title {
    font-size: 0.22rem;
    color: #b9b9b9;
    margin-top: 0.4rem;
}

.support-people {
    position: relative;
    /* display: flex;
    justify-content: flex-start;
    align-items: center; */
    margin-top: 0.5rem;
    width: 5.6rem;
    height: 0.75rem;
    text-align: left;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
}

.people-item {
    position: relative;
    /* z-index: 2; */
    width: 100%;
    height: 100%;
    text-align: left;

}

.people-headimg {
    position: relative;
    display: inline-block;
    z-index: 2;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    background: #e8eff1;
    border: 2px solid #e8eff1;
    margin-right: 0.85rem;
    white-space: nowrap;
}

.people-headimg img {
    width: 100%;
    border-radius: 50%;
}

.line {
    position: absolute;
    top: 50%;
    right: -1.35rem;
    transform: translateX(-50%);
    width: 0.9rem;
    height: 0.08rem;
    background: #e8eff1;
}

.right-line {
    position: absolute;
    top: 50%;
    right: -0rem;
    transform: translateY(-50%);
    width: 100%;
    height: 0.08rem;
    background: #e8eff1;
    z-index: 1;
}

.rank-btn {
    width: 5.23rem;
    height: 0.86rem;
    line-height: 0.86rem;
    text-align: center;
    background: url('../../assets/H5img/support/rank-btn.png') no-repeat;
    background-size: cover;
    background-position: center;
    margin-top: 0.8rem;
}

.support-tips {
    width: 2.61rem;
    height: 0.19rem;
    background: url('../../assets/H5img/support/tips.png') no-repeat;
    background-size: cover;
    background-position: center;
    margin: 0 auto;
    color: #b9b9b9;
    font-size: 0.18rem;
    margin-top: 0.3rem;
}
</style>
